query CardHolder($id: UUID!) {
  cardHolder(id: $id) {
    id
    cardAccountId
    _isDeletable
    _rowTimestamp
    _isUpdatable
    _isTagsExist
    cardFirstName
    cardLastName
    cardFullName
    cardNumber
    cardExpiry
    departmentId
    userGroupId
    documentPoolId
    tenantUserId
    departments {
      name
    }
    documentPools {
      name
    }
    cardStatus
    statusType {
      statusType
    }
    entityTagsByEntityId {
      nodes {
        id
        _isDeletable
        _tagBadgeName
        _tagBadgeColor
        _rowTimestamp
      }
    }
    cardHolderHistoriesByEntityId {
      nodes {
        crudOperation
        tenantUserName
        pointInTimeDate
      }
    }
    cardAccounts {
      companyCardCompanies {
        _isManualProcess
      }
    }
    cardHolderTransactions {
      nodes {
        id
        linkInvoiceId
        transactionDate
        entryDate
        description
        _entityDocumentId
        cardTransactionType
        amount
        currencyId
        currency {
          isoCode
        }
        statusType {
          statusType
        }
      }
    }
    notesByEntityId {
      nodes {
        noteComment
      }
    }
  }
}
